export default {
    namespaced: true, // Ensure namespacing is enabled
    state: {
      all: [
        { id: 1, title: "Product 1", price: 100, inventory: 10 },
        { id: 2, title: "Product 2", price: 200, inventory: 5 },
        { id: 3, title: "Product 3", price: 300, inventory: 0 },
      ],
    },
    
    getters: {
      all: (state) => state.all,
    },

    mutations: {
      decrementProductInventory(state, { id }) {
        const product = state.all.find((product) => product.id === id);
        if (product) product.inventory--;
      },
    },
  };
  